import {Injectable} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {ReportsV2Service as ReportsApiService} from '../../api/services/reports-v-2.service';
import {ActivityDashboardResponse} from '../../api/models/activity-dashboard-response';
import {ActivityDashboardService as ActivityDashboardApiService} from '../../api/services/activity-dashboard.service';
import {CallLogsFilterModel} from '../../api/models/call-logs-filter-model';
import {AdGrandTotalModel} from '../../api/models/ad-grand-total-model';

@Injectable()
export class ActivityDashboardV2Service {

  public dashboardData: ActivityDashboardResponse = {
    grandTotal: {} as AdGrandTotalModel,
    topByNumber: [],
    topByGroup: [],
    topByUser: [],
    timeSeriesTotals: []
  };

  public selectedRefreshTitle = 'Auto Refresh - Off';
  public selectedRefreshTime = 0;
  public refreshRanges = [
    {action: 0, text: 'Auto Refresh - Off'},
    {action: 10, text: 'Every 10 sec'}
  ];

  public topRanges = [
    {action: 1, text: 'Top 1'},
    {action: 2, text: 'Top 2'},
    {action: 3, text: 'Top 3'},
    {action: 4, text: 'Top 4'},
    {action: 5, text: 'Top 5'},
    {action: 6, text: 'Top 6'}
  ];

  public chartRanges = [
    {action: 1, text: '1 Hour'},
    {action: 6, text: '6 Hours'},
    {action: 24, text: '1 Day'}
  ];

  public chartSelectedItem;
  public topNumberRangeSelectedItem;
  public topGroupRangeSelectedItem;
  public topUserRangeSelectedItem;

  constructor(private authService: AuthService, private activityDashboardApiService: ActivityDashboardApiService) {
    this.topNumberRangeSelectedItem = this.topRanges[2];
    this.topGroupRangeSelectedItem = this.topRanges[2];
    this.topUserRangeSelectedItem = this.topRanges[2];
    this.chartSelectedItem = this.chartRanges[1];
  }

  getDashboardGrandTotals(filter: CallLogsFilterModel) {
    return this.activityDashboardApiService.activityDashboardV2GetActivityDashboardGrandTotals({
      body: {
        filter: filter
      }
    }).toPromise();
  }

  getDashboardTimeSeriesTotals(filter: CallLogsFilterModel) {
    return this.activityDashboardApiService.activityDashboardV2GetActivityDashboardTimeSeriesTotals({
      body: {
        filter: filter
      }
    }).toPromise();
  }

  getDashboardTopByGroupTotals(filter: CallLogsFilterModel) {
    return this.activityDashboardApiService.activityDashboardV2GetActivityDashboardTopByGroupTotals({
      body: {
        filter: filter
      }
    }).toPromise();
  }

  getDashboardTopByAgentTotals(filter: CallLogsFilterModel) {
    return this.activityDashboardApiService.activityDashboardV2GetActivityDashboardTopByAgentTotals({
      body: {
        filter: filter
      }
    }).toPromise();
  }
}
